import { Injectable, NgZone, PLATFORM_ID, inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { i18n } from '@app/shared/language/i18n';
import { readSessionAccount } from '@shared/services/account-switch/account-switch.util';
import { LocalStorageKey } from '@shared/services/local-storage.service';
import { AUTH_TAB_SYNC_MODAL_CLASS } from './auth-tab-sync.constants';

@Injectable({ providedIn: 'root' })
export class AuthTabSyncService {
  private readonly platformId = inject(PLATFORM_ID);
  private readonly modal = inject(NzModalService);
  private readonly translate = inject(TranslateService);
  private readonly ngZone = inject(NgZone);

  private noticeShown = false;

  public init(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    window.addEventListener('storage', (event) => this.handleStorage(event));
  }

  private handleStorage(event: StorageEvent): void {
    if (
      this.noticeShown ||
      event.key !== LocalStorageKey.PIFAGOR_API_AUTH_TOKEN
    ) {
      return;
    }

    const previousUserId = readSessionAccount(event.oldValue)?.id ?? null;
    const nextUserId = readSessionAccount(event.newValue)?.id ?? null;

    if (previousUserId === nextUserId) {
      return;
    }

    this.noticeShown = true;
    this.ngZone.run(() =>
      this.modal.info({
        nzTitle: this.translate.instant(i18n.auth_tab_sync.title),
        nzContent: this.translate.instant(i18n.auth_tab_sync.body),
        nzOkText: this.translate.instant(i18n.auth_tab_sync.reload),
        nzClassName: AUTH_TAB_SYNC_MODAL_CLASS,
        nzClosable: false,
        nzMaskClosable: false,
        nzKeyboard: false,
        nzOnOk: () => window.location.reload(),
      }),
    );
  }
}
